module.exports = __webpack_public_path__ + "img/live5.242c64b0.png";